import { CounterCustomerChargeEntity } from "domain/entity/CounterCustomerCharge/CounterCustomerChargeEntity";
import { CounterCustomerChargeMaintenanceConstant } from "presentation/constant/CounterCustomerCharge/CounterCustomerChargeMaintenanceConstant";
import { useCounterCustomerChargeMaintenanceVM } from "presentation/hook/CounterCustomerCharge/useCounterCustomerChargeMaintenanceVM";
import { useMessageBarVM } from "presentation/hook/useMessageBar";
import { useCounterCustomerChargeMaintenanceTracked } from "presentation/store/CounterCustomerCharge/CounterCustomerChargeMaintenanceProvider";
import { HeaderTitle } from "presentation/view/components/HeaderWithBackButton/HeaderTitle";
import { NbisCommonField } from "presentation/view/components/NbisCommonField";
import { memo, useCallback, useMemo, useState } from "react";
import { FieldType, HPHButton, IFieldValue, Loader } from "veronica-ui-component/dist/component/core";
import { SidebarActionBar, Sidebarheader } from "veronica-ui-component/dist/component/core/styled/uiFramework.styled";

const UpdateBillToCompanyPanel = () => {
    const [counterCustomerChargeState] = useCounterCustomerChargeMaintenanceTracked();
    const counterCustomerChargeVM = useCounterCustomerChargeMaintenanceVM();
    const COUNTER_CUSTOMER_CHARGE_CONSTANT = CounterCustomerChargeMaintenanceConstant.Detail;
    const { editingEntity, allFormState } = counterCustomerChargeState;
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const messageBarVM = useMessageBarVM();

    const handleSaveClick = useCallback(async () => {
        setIsLoading(true);
        let entityList: CounterCustomerChargeEntity[] = [];

        //add logic to check cannot allow transfer back to SL if it is transferFromSL is Y
        if (counterCustomerChargeState.allSLCompanies?.find(company => editingEntity?.billToCompany === company)) {
            let allTransferFromSL = counterCustomerChargeState.selectedRows.find(item => item.transferFromSL === 'Y');
            if (allTransferFromSL) {
                messageBarVM.showError('These transferred charges with bill to company does not allow to transfer back to SL again.');
                setIsLoading(false);
                return;
            }
            if (editingEntity?.additionalChargeInd === 'Y') {
                messageBarVM.showError('Additional Charge cannot be transferred to shipping line.');
                setIsLoading(false);
                return;
            }
        }

        counterCustomerChargeState.selectedRows.forEach(item => {
            item.billToCompany = editingEntity?.billToCompany;
            entityList.push(item);
        });
        counterCustomerChargeVM.onValidationBillToCompanyCode(entityList[0]).then(data => {
            if (data) {
                counterCustomerChargeVM.onSave(entityList).then((res) => {
                    if (res && res.success) {
                        messageBarVM.showSuccess('Save Successfully.');
                        counterCustomerChargeVM.onMoreClose();
                        counterCustomerChargeVM.onSearchCounterCustomer(counterCustomerChargeState.searchCriteria);
                    } else {
                        messageBarVM.showError('Save Failed.');
                    }
                    setIsLoading(false);
                });
            } else {
                setIsLoading(false);
            }
        });
    }, [counterCustomerChargeState.allSLCompanies, counterCustomerChargeState.selectedRows, counterCustomerChargeState.searchCriteria,
        counterCustomerChargeVM, editingEntity?.billToCompany, messageBarVM, editingEntity?.additionalChargeInd]);

    const handClose = useCallback(() => {
        counterCustomerChargeVM.onMoreClose();
    }, [counterCustomerChargeVM]);

    const memoBillToCompany = useMemo(() =>
        <div className='im-flex-row-item' style={{ width: "220px", marginBottom: "24px", marginLeft: "15px" }}>
            <NbisCommonField
                errorMessages={allFormState}
                isReadOnly={false}
                isShowOptional={false}
                readOnlyValue={editingEntity?.billToCompany || ''}
                fieldValue={editingEntity?.billToCompany}
                fieldLabel={COUNTER_CUSTOMER_CHARGE_CONSTANT.BILL_TO_COMPANY}
                fieldType={FieldType.DROPDOWN}
                fieldKey={'billToCompany'}
                maxLength={60}
                isLimitOptions={true}
                options={counterCustomerChargeState.dynamicOptions.billToCompDropdownOptions}
                requiredFieldList={[]}
                isSaveClicked={true}
                onFieldChange={(fieldKey: string, fieldValue: IFieldValue, fFullValue?: any) =>
                    counterCustomerChargeVM.onCounterCustomerFieldChange(fieldKey, fieldValue && fieldValue.toString(), fFullValue)} />
        </div>
        , [allFormState, COUNTER_CUSTOMER_CHARGE_CONSTANT.BILL_TO_COMPANY, editingEntity?.billToCompany, counterCustomerChargeState.dynamicOptions.billToCompDropdownOptions, counterCustomerChargeVM])


    return (<div className='side-form-content-left-wrapper' style={{ padding: "20px 20px 20px 0px" }}>
        <div className={'flex-row'}>
            <div className={'flex-row-item flex-row-item-full-width'}>
                <Sidebarheader>
                    <HeaderTitle>{"Update Bill-To Company"}</HeaderTitle>
                </Sidebarheader>
            </div>
        </div>

        {isLoading && <Loader Indicator="Spinner" size="Medium" />}

        <div className={'add-edit-form'} style={{ maxHeight: '75vh', height: '75vh', overflow: 'auto' }}>
            <div className="flex-row-auto">
                <div className={'flex-row-item'}>
                    {memoBillToCompany}
                </div>
            </div>
        </div>
        <SidebarActionBar>
            <HPHButton label={'Close'} size={'Small'} theme={'Secondary'} onClick={handClose} />
            <HPHButton label={'Save'} size={'Small'} theme={'Primary'} onClick={() => handleSaveClick()} />
        </SidebarActionBar>
    </div>)
}

export default memo(UpdateBillToCompanyPanel);